import type { ReactNode } from "react";
import { cn } from "@/lib/utils";
import { WilsonFace } from "./WilsonFace";
import { Keycap } from "./SectionLabel";
import { FOCUS_RING } from "./focusRing.constants";
export function AskRow({
  children,
  shortcut,
  isSelected = false,
  hasFace = true,
  onSelect,
  id
}: {
  children: ReactNode;
  shortcut?: string;
  isSelected?: boolean;
  hasFace?: boolean;
  onSelect: () => void;
  id?: string;
}) {
  return <button type="button" id={id} role="option" aria-selected={isSelected} onClick={onSelect} className={cn("flex h-11 w-full items-center gap-3 rounded-xl px-3 text-left text-body text-ink", "transition-colors duration-fast", FOCUS_RING, isSelected ? "bg-offwhite" : "hover:bg-ink/[0.04]")} data-sentry-component="AskRow" data-sentry-source-file="AskRow.tsx">
            {hasFace && <span className="flex h-6 w-6 flex-shrink-0 items-center justify-center text-ink">
                    <WilsonFace variant="bare" className="h-3" />
                </span>}
            <span className="min-w-0 flex-1 truncate">{children}</span>
            {shortcut && <Keycap>{shortcut}</Keycap>}
        </button>;
}